import React from "react";

import classNames from "classnames";
let $window = require("../legacy/helpers/helpers").default.window;

class Carousel extends React.Component {
    state = {
        page: 1
    };

    scrollLeft = () => {
        if (this.state.page <= 1) return;
        this.setState(prevState => ({ page: prevState.page - 1 }));
    };

    scrollRight = lastPage => {
        if (this.state.page >= lastPage) return;
        this.setState(prevState => ({ page: prevState.page + 1 }));
    };

    getCurrentItems(items, itemsPerPage) {
        const { page } = this.state;

        let start = (page - 1) * itemsPerPage;
        let end = page * itemsPerPage;

        if (start >= items.length || end >= items.length) {
            start = Math.min(items.length - itemsPerPage, start);
            end = Math.min(items.length, end);
        }

        return items.slice(start, end);
    }

    render() {
        if (!this.props.items.length) return <div>Loading…</div>;

        const itemsPerPage =
            $window.width() <= 960 ? 1 : this.props.itemsPerView;
        const lastPage = Math.floor(this.props.items.length / itemsPerPage);

        return (
            <div>
                <div
                    className={classNames(
                        "collection-list_arrow left-arrow ui_left-arrow",
                        {
                            disabled: this.state.page === 1
                        }
                    )}
                    onClick={this.scrollLeft}
                />
                <div className="carousel margin-t-s">
                    {this.getCurrentItems(this.props.items, itemsPerPage)}
                </div>
                <div
                    className={classNames(
                        "collection-list_arrow right-arrow ui_right-arrow",
                        {
                            disabled: this.state.page >= lastPage
                        }
                    )}
                    onClick={() => this.scrollRight(lastPage)}
                />
            </div>
        );
    }
}

export default Carousel;
